import Handsontable from 'handsontable';
import Vue from 'vue';
import { MutationTree } from 'vuex';

import { subscribableStore } from '@/datura/history/store/common';
import { UserColumnSettings } from '@/shared/handsontable/rework/types';

import { DaturaHistoryState } from './types';

const mutations: MutationTree<DaturaHistoryState> = {
  ...subscribableStore.mutations,
  setHot(state, hot: Handsontable | null) {
    Vue.set(state, 'hot', hot);
  },
  setUserColumnSettings(state, userColumnSettings: Record<string, UserColumnSettings>) {
    Vue.set(state, 'userColumnSettings', userColumnSettings);
  },
};

export default mutations;
